export const NOTICE_PAGES = {
  CHECKOUT: 'checkout',
};

export const NOTICE_SLOTS = {
  PRODUCTS: 'products',
  HEADER: 'header',
};
